export const NODE_IDS = ["bridge", "reactor", "breaker_bay", "storage"] as const;
export type NodeId = (typeof NODE_IDS)[number];

export type Phase = "lobby" | "running" | "won" | "lost";
export type ToggleStatus = "idle" | "tripped" | "lockout";
export type HoldStatus = "ready" | "waiting" | "engaged" | "cooldown";
export type HoldOutcome = "" | "success" | "fail";
export type ReplaceStatus = "idle" | "damaged" | "carried" | "done";

/** Power sinks. The reactor never makes enough for all three at full demand. */
export const POWER_SYSTEMS = ["cooling", "life", "comms"] as const;
export type PowerSystem = (typeof POWER_SYSTEMS)[number];

export const SWITCH_IDS = ["B1", "B2", "B3", "B4"] as const;
export type SwitchId = (typeof SWITCH_IDS)[number];

export const HANDLE_IDS = ["A", "B"] as const;
export type HandleId = (typeof HANDLE_IDS)[number];

/** The six verbs. Every task is one of these, reskinned. A seventh needs a design discussion first. */
export const VERBS = ["toggle", "calibrate", "hold", "route", "replace", "confirm"] as const;
export type Verb = (typeof VERBS)[number];
